export default __webpack_public_path__ + "static/media/Boots of the Victorious Elite.d4786f26.jpg";